import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import { MultiSelectTagWithoutOptionsFragmentDoc } from './MultiSelectTagWithoutOptions';
import { SharedByWorkspaceFragmentDoc } from '../../../../../../../../lyearn-connect/views/LyearnConnectDetails/graphql/fragments/generated/sharedByWorkspace';
import { IntegrationProviderLiteFragmentDoc } from '../../../../../../integrations/graphql/fragments/generated/IntegrationProviderLite';
export type MultiSelectTagWithIntegrationProviderFragment = { id: string, name: string, description?: string | null, availableOn: Array<Types.TagAvailableOnEnum>, type: Types.TagTypeEnum, subWorkspaces?: Array<string> | null, category?: Types.TagCategoryEnum | null, source?: string | null, subType?: Types.TagSubTypeEnum | null, integrationProvider?: { id: string, name: string, provider: Types.IntegrationProviderEnum } | null, settings: { availableInLibrary: boolean, requiredTag: boolean, iconSettings: { type: Types.IconTypeEnum, value: string } }, createdBy?: { id: string, name?: string | null } | null, sharedByWorkspace?: { workspaceId: string, workspaceName: string, workspaceLogo?: string | null, uri: string, icon?: string | null } | null };


export type MultiSelectTagWithIntegrationProviderFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export const MultiSelectTagWithIntegrationProviderFragmentDoc = /*#__PURE__*/ gql`
    fragment MultiSelectTagWithIntegrationProvider on MultiSelectTagType {
  ...MultiSelectTagWithoutOptions
  integrationProvider {
    ...IntegrationProviderLite
  }
}
    `;